require('../../modules/es6.number.is-safe-integer');
module.exports = require('../../modules/_core').Number.isSafeInteger;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/number/is-safe-integer.js
// module id = 1115
// module chunks = 0